import styled from 'styled-components';
import { SingleSelectMenu } from '../../Dropdown';
import { theme } from '../../../styles/theme';

export const Container = styled.div`
  width: 253px;
  padding: 12px;
`;

export const FormRow = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 70px 1fr;
  grid-column-gap: 8px;
`;

export const FormLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  text-align: right;
  color: ${theme.colors.secondary800};
`;

export const CalculationContainer = styled.div`
  display: flex;
  column-gap: 8px;
`;

export const CalculationUnitMenu = styled(SingleSelectMenu)`
  flex: 1;
`;

export const CalculationValueMenu = styled.div`
  flex: 0 0 90px;
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  column-gap: 12px;
  margin-top: 16px;
`;
